<template>
  <modal-dialog :visible="isVisible" :id="modalDialogId" class="print-dialog">
    <div slot="header">
      <h5>{{ title }}</h5>
    </div>

    <div slot="body">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="showPrintPreviewImage" @click="showPrintPreviewImage" ref="showPrintPreviewImage">
            <label class="form-check-label" for="showPrintPreviewImage">
                {{ translate('label.modal.print.preview_image') }}
            </label>
        </div>
    </div>

    <div slot="footer">
      <button type="button" class="btn btn-light" @click="onPrint">
          <img src="/img/print-trans.svg"> {{ translate('label.modal.button.print') }}</button>
    </div>
  </modal-dialog>
</template>

<script>
    export default {
        props: {
            title: { type: String, required: true, default: "Print" }
        },

        created() {
            EventDispatcher.listen('showPrintDialog', () => {
                EventDispatcher.fire('showDialog' + this.modalDialogId, true);
            });
        },
        
       data() {
           return {
               isVisible: false,
                modalDialogId: 'printModalDialog'
           }
       },

        methods: {
            onPrint() {
                EventDispatcher.fire('expandTruncatedText');
                EventDispatcher.fire('showDialog' + this.modalDialogId, false);
                EventDispatcher.fire('print', false);
                EventDispatcher.fire('collapseTruncatedText');
            },

            showPrintPreviewImage() {
                EventDispatcher.fire('showPreviewImage', this.$refs.showPrintPreviewImage.checked);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @media print {
        .print-dialog {
            display: none;
        }
    }
</style>